import "./UIRect.css"
import React from 'react'
import classnames from "classnames"

const UIRect = ({ width, height, cornerWidth, ...props })=> {
  const points = [
    0, 0,
    width - cornerWidth, 0,
    width, cornerWidth,
    width, height,
    0, height,
    0, 0
  ]
  const className = classnames("UIRect", props.className)
  return <div className={className}>
    <svg
      viewBox={`0 0 ${width} ${height}`}
      shapeRendering="auto" 
      width={width + 2} 
      height={height + 2}>
      <polygon 
        fill="url(#gradient)"
        fillOpacity={1} 
        stroke={props.borderColor}
        strokeWidth="1"
        strokeOpacity=".5"
        style={{filter:"url(#window-glow)"}}
        points={points.join(",")} />
      <filter id="window-glow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
          </feMerge>
      </filter>
      <linearGradient id="gradient" spreadMethod="reflect" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={props.backgroundColor} />
        <stop offset="10%" stopColor={props.backgroundColor} stopOpacity="0.66" />
        <stop offset="100%" stopColor={props.backgroundColor} stopOpacity="0.33"  />
      </linearGradient>       
    </svg>
  </div>
}



UIRect.defaultProps = {
  backgroundColor: "#000",
  borderColor: "#3c8aba",
}

export default UIRect


// WEBPACK FOOTER //
// ./src/components/UIRect.js